import { createReducer, on } from '@ngrx/store'
import * as FeatureEPActions from './feature-ep.actions'
import { FeatureEPState } from './feature-ep.state'

export const initialState: FeatureEPState = {
   soughtPartnerTableItems: [],
}

export const featureEPReducer = createReducer(
   initialState,
   on(FeatureEPActions.cleanSoughtPartnerTable, (state) => ({ ...state, soughtPartnerTableItems: [] })),
   on(FeatureEPActions.addSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnerTableItems: [...state.soughtPartnerTableItems.concat(action.body)],
   })),
   on(FeatureEPActions.removeSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnerTableItems: [...state.soughtPartnerTableItems.filter((item, index) => index !== action.id)],
   })),
   on(FeatureEPActions.replaceSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnerTableItems: [
         ...state.soughtPartnerTableItems.map((item, index) => {
            if (index == action.id) {
               item = action.body
            }
            return item
         }),
      ],
   })),
   on(FeatureEPActions.initSoughtPartnerTable, (state, action) => ({ ...state, soughtPartnerTableItems: action.body }))
)
